import React from 'react'
import Link from 'next/link'
import { Header2, Text } from '../../styles/Components'
import styled from '@emotion/styled'
import { mq } from '../../helpers'

const CancelWrapper = styled.section`
  width: 100%;
  max-width: 1600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 72px 16px;
  text-align: center;
  gap: 18px;

  ${mq('max', '768px')} {
    padding: 48px 16px;
    gap: 26px;
  }

  a {
    color: #000;
    font-weight: 600;
    text-decoration: underline;

    &:visited {
      color: #000;
    }
  }
`

const Cancellation = () => (
  <CancelWrapper>
    <Header2 align="center">Need to change your appointment?</Header2>
    <div>
      <Text lineHeight="138%" spacing={0.96} textAlign="center">
        Sometimes life gets in the way.{' '}
        <Link href="/faq">
          See our cancellation policy here.
        </Link>
      </Text>
      <Text lineHeight="138%" spacing={0.96} textAlign="center" margin="20px 0 0 0">
        If you&apos;ve got more questions,{' '}
        <Link href="/faq">
          check out our FAQs.
        </Link>
      </Text>
    </div>
  </CancelWrapper>
)

export default Cancellation
